import { Injectable } from '@angular/core';

@Injectable()
export class TableContextService {
  private tableId: string = '';

  public setTableId(tableId: string): void {
    this.tableId = tableId;
  }

  public getTableId(): string | undefined {
    return this.tableId || undefined;
  }
}

